import type { VocabEntry } from "../context/types";
import { OptionGroup } from "./OptionGroup";

type ImageCardGridProps = {
  options: VocabEntry[];
  value: string | null;
  onValueChange: ({ value }: { value: string | null }) => void;
};

export function ImageCardGrid({
  options,
  value,
  onValueChange,
}: ImageCardGridProps) {
  return (
    <OptionGroup
      options={options.map((option) => ({
        id: option.id,
        label: option.label_nl,
      }))}
      value={value}
      onValueChange={onValueChange}
    />
  );
}
